module.exports = __webpack_public_path__ + "img/Balance_connectee_pro.04326f3b.png";